// frontend/src/api/orgDetails.js

async function parseResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const detail = isJson && payload ? payload.detail : null;
    const message =
      (isJson && payload && payload.message) ||
      (typeof detail === "string" && detail) ||
      (detail && typeof detail === "object" && (detail.error || JSON.stringify(detail))) ||
      (typeof payload === "string" && payload) ||
      `${res.status} ${res.statusText}`;
    throw new Error(message);
  }

  return payload;
}

/**
 * GET /api/organizations/details
 * Returns [{ ff_org_id, name, auth_provider, provider_org_id, error }]
 */
export async function getOrgDetails() {
  const res = await fetch("/api/organizations/details", {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  return parseResponse(res);
}
